import { render, staticRenderFns } from "./MenuContentLabel.vue?vue&type=template&id=cc634d46&scoped=true&"
import script from "./MenuContentLabel.vue?vue&type=script&lang=js&"
export * from "./MenuContentLabel.vue?vue&type=script&lang=js&"
import style0 from "./MenuContentLabel.vue?vue&type=style&index=0&id=cc634d46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc634d46",
  null
  
)

export default component.exports